import { GraphQLFormattedError } from 'graphql/error'

export class FormValidation {
  static fromGraphqlErrors(
    graphQLErrors: ReadonlyArray<GraphQLFormattedError> = [],
  ): Object | null {
    return (
      graphQLErrors
        .filter(({ extensions: { validation } = {} }) => validation)
        .map(({ extensions }) => extensions?.validation)[0] || null
    )
  }

  // Returns the first validation error from each array of validation errors
  static getSingularGraphqlErrors(
    graphQLErrors: ReadonlyArray<GraphQLFormattedError> = [],
    prefix = '',
  ): Object {
    return Object.entries(this.fromGraphqlErrors(graphQLErrors) ?? {}).reduce(
      (errorObject, [errorKey, errorMessages]) => ({
        ...errorObject,
        [prefix !== '' ? errorKey.replace(prefix, '') : '']: errorMessages[0],
      }),
      {},
    )
  }

  static containsFormValidations(graphQLErrors: ReadonlyArray<GraphQLFormattedError> = []) {
    return graphQLErrors.filter(({ extensions: { validation } = {} }) => validation).length > 0
  }

  static containsErrorMessage(graphQLErrors: ReadonlyArray<GraphQLFormattedError> = []) {
    return graphQLErrors[0]?.message
  }
}
